module.exports = __webpack_public_path__ + "img/diagram_021.d643e6fb.svg";